const TRAILS = [
  {
    name: 'Whiteside Mountain Trail',
    icon: 'ri-mountain-line',
    distance: '2 miles roundtrip',
    description:
      'One of the most iconic hikes in the Highlands area, Whiteside Mountain offers sweeping views from exposed granite cliffs and a well-maintained loop trail through mixed forest. A rewarding outing for dogs that enjoy varied terrain — leash required throughout.',
  },
  {
    name: 'Glen Falls Trail',
    icon: 'ri-water-flash-line',
    distance: '2 miles roundtrip',
    description:
      "A beautiful, forested trail leading to a series of cascading waterfalls along Glen Falls Creek. The path winds through rhododendron tunnels and alongside the creek, making it one of the most scenic and dog-friendly things to do in Highlands NC. Dogs must be kept on a leash at all times.",
  },
  {
    name: 'Satulah Mountain Trail',
    icon: 'ri-compass-3-line',
    distance: '1.5 miles roundtrip',
    description:
      'A short but rewarding climb just outside of downtown Highlands, Satulah Mountain offers panoramic views of the surrounding mountains and valleys. The quiet trail is well-suited for dogs, with a gentle pace and plenty of shade. Leash required.',
  },
];

export default function TrailsSection() {
  return (
    <section className="bg-[#FAFAF8] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center mb-16">
          <div>
            <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Leash Required</p>
            <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light mb-6">
              Dog-Friendly<br /><em className="italic">Hiking Trails</em>
            </h2>
            <p className="text-[#5C5850] font-jost text-sm leading-relaxed">
              The Highlands area is home to some of the most beautiful trail systems in the Southern Appalachians. All of the trails below welcome leashed dogs and offer memorable scenery for both people and pets. Dog-friendly things to do in Highlands NC start right here.
            </p>
          </div>
          <div className="rounded-2xl overflow-hidden h-[320px]">
            <img
              src="https://public.readdy.ai/ai/img_res/c98e4e0016654887b0991986e1cc625a.jpg"
              alt="Dog-friendly hiking trails near Highlands NC"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TRAILS.map((trail) => (
            <article key={trail.name} className="bg-white rounded-2xl p-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EDE8E0] mb-5">
                <i className={`${trail.icon} text-[#2D4A3E] text-xl`} />
              </div>
              <h3 className="font-cormorant text-2xl text-[#1A1A18] font-medium mb-1 leading-snug">{trail.name}</h3>
              <span className="text-[#9C9890] text-xs font-jost tracking-wide block mb-4">{trail.distance}</span>
              <p className="text-[#5C5850] text-sm font-jost leading-relaxed">{trail.description}</p>
              <div className="mt-5 flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-information-line text-[#C9A96E] text-sm" />
                </div>
                <span className="text-[#9C9890] text-xs font-jost italic">Dogs must be on a leash</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
